import { ReferenceLineStyle } from './reference-line-style';

const STROKES: Record<ReferenceLineStyle, number[]> = {
  solid: [],
  dotted: [2, 2],
  dashed: [10, 3],
};

export function getStrokePatternForReferenceLine(style: ReferenceLineStyle) {
  return STROKES[style] ?? [];
}
